import { Type } from 'class-transformer';
import { Artstamm } from './Artstamm';
import { OffeneBestellung } from './OffeneBestellung';

export class ArtstammScan {
    @Type(() => Artstamm)
    public artstamm: Artstamm;
    @Type(() => OffeneBestellung)
    public offeneBestellungen: Array<OffeneBestellung>;
}



// WEBPACK FOOTER //
// ./src/providers/rest-server/data/ArtstammScan.ts